module.exports = __webpack_public_path__ + "img/logo-red.316c104d.svg";